import { Logo } from '../../app/Brand';

export function SetupPage() {
  return (
    <div className="flex h-full items-center justify-center bg-band px-4">
      <div className="w-full max-w-2xl overflow-hidden rounded-xl border border-line bg-white shadow-sm">
        <div className="bg-navy px-6 py-5 text-white">
          <Logo onNavy className="h-7" />
          <h1 className="mt-3 text-xl font-semibold">Connect the app to its database</h1>
        </div>
        <div className="h-1 bg-gold" />
        <div className="space-y-4 px-6 py-6 text-sm">
          <p>
            This build has no Supabase project configured. The app runs entirely against Supabase (Postgres, Google sign-in, Row Level Security), so it needs the project URL and anon key before anyone can sign in.
          </p>
          <ol className="list-decimal space-y-2 pl-5">
            <li>
              Create the Supabase project under the company account, then in this repository run <code className="rounded bg-band px-1">supabase link --project-ref &lt;ref&gt;</code> and <code className="rounded bg-band px-1">supabase db push</code> to apply the schema, followed by the seed.
            </li>
            <li>Enable the Google provider under Authentication &gt; Providers and add this site URL to the redirect list.</li>
            <li>
              Copy <code className="rounded bg-band px-1">apps/web/.env.example</code> to <code className="rounded bg-band px-1">apps/web/.env</code> and fill in <code className="rounded bg-band px-1">VITE_SUPABASE_URL</code> and <code className="rounded bg-band px-1">VITE_SUPABASE_ANON_KEY</code>.
            </li>
            <li>Restart the dev server. The seeded admin invitation activates on that person&apos;s first Google sign-in.</li>
          </ol>
          <p className="text-ink-muted">The README in the repository root walks through each step.</p>
        </div>
      </div>
    </div>
  );
}
